import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as NotificationActions from './notification.actions';
import { NotificationEntity } from './notification.models';

export const NOTIFICATION_FEATURE_KEY = 'notification';

export interface State extends EntityState<NotificationEntity> {
  selectedId?: string | number; // which Notification record has been selected
  loading: boolean; // Notification is loading
  saving: boolean;
  error?: string | null; // last none error (if any)
  maxId: number;
}

export interface NotificationPartialState {
  readonly [NOTIFICATION_FEATURE_KEY]: State;
}

export function selectNotificationId(notification: NotificationEntity): string {
  return notification.message;
}

export const notificationAdapter: EntityAdapter<NotificationEntity> = createEntityAdapter<
  NotificationEntity
>({
  selectId: selectNotificationId
});

export const initialState: State = notificationAdapter.getInitialState({
  // set initial required properties
  loading: false,
  saving: false,
  maxId: 0
});

const notificationReducer = createReducer(
  initialState,
  on(NotificationActions.loadNotifications, state =>
  ({
    ...state,
    loading: true,
    error: null
  })
  ),
  on(NotificationActions.loadNotificationsSuccess, (state, { notifications }) =>
    notificationAdapter.addMany(notifications, { ...state, loading: false })
  ),
  on(NotificationActions.loadNotificationsFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false
  })),

  on(NotificationActions.addNotification, state => ({
    ...state,
    saving: true,
    error: null
  })),
  on(NotificationActions.addNotificationSuccess, (state, { notification }) => {
    return notificationAdapter.addOne(notification, {
      ...state,
      saving: false
    });
  }),
  on(NotificationActions.addNotificationFailure, (state, { error }) => ({
    ...state,
    saving: false,
    error
  })),

  on(NotificationActions.deleteNotification, state => ({
    ...state,
    saving: true,
    error: null
  })),
  on(NotificationActions.deleteNotificationSuccess, (state, { id }) => {
    return notificationAdapter.removeOne(id.toString(), {
      ...state,
      saving: false
    });
  }),
  on(NotificationActions.deleteNotificationFailure, (state, { error }) => ({
    ...state,
    saving: false,
    error
  })),
  on(NotificationActions.clearAllNotification, (state) => {
    return notificationAdapter.removeAll(state);
  })
);

export function reducer(state: State | undefined, action: Action) {
  return notificationReducer(state, action);
}
